export default "__VITE_ASSET__C0HNtujF__"